import React from 'react'
import { Select, Tag } from 'antd'

const { Option } = Select

class PartnerProfileBuildingTypeSelect extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    function tagRender(props) {
      const { value, closable, onClose } = props
      const onPreventMouseDown = (event) => {
        event.preventDefault()
        event.stopPropagation()
      }
      return (
        <Tag onMouseDown={onPreventMouseDown} closable={closable} onClose={onClose} style={{ marginRight: 3 }}>
          {value}
        </Tag>
      )
    }

    return (
      <Select
        placeholder='please select building type'
        {...this.props}
        allowClear
        showArrow
        tagRender={tagRender}
        style={{ width: '100%' }}
      >
        <Option value='luxury'>Luxury</Option>
        <Option value='high-end'>High-end</Option>
        <Option value='general'>General</Option>
        <Option value='others'>Others</Option>
      </Select>
    )
  }
}

export default PartnerProfileBuildingTypeSelect
